import {formatReferenceCopy as formatDemoCopy} from 'utils/typography';
import React from 'react';
import {useTranslation} from 'react-i18next';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import {Completed, ExpandMore, LocalPolice} from '@vedmarket/ui-kit';

import {COLORS} from '../../../../../../../config/constants';
import {useUserBrokerService} from '../../../../../../../api/calc';
import {numberWithSpaces} from '../../../../../../../utils/helpers';

import './broker-commission.scss';

const BrokerCommission = () => {
  const { t } = useTranslation();

  const userBrokerService = useUserBrokerService();

  if (!userBrokerService) {
    return null;
  }

  const commission = `${numberWithSpaces(userBrokerService.commission || 0)} USD`;
  const completedInfo = [
    {
      label: formatDemoCopy(t('calc__text__customs__customsBrokerCommission')),
      value: commission,
    },
  ];

  return (
    <div className='broker-commission'>
      <Accordion defaultExpanded sx={{
        marginBottom: 0,
        border: `1px solid ${COLORS.SLIGHTLY_GRAY}`,
        boxShadow: 'none',
        '&.Mui-expanded': {
          marginBottom: 0,
        },
      }}>
        <AccordionSummary expandIcon={<ExpandMore/>} sx={{
          padding: '24px',
          minHeight: '74px',
          '&.Mui-expanded': {
            minHeight: '74px',
            paddingBottom: '23px',
          },
          '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded': {
            margin: 0,
          },
          '& .MuiAccordionSummary-expandIconWrapper': {
            color: COLORS.LIGHT_ACTION,
            marginLeft: '16px',
          },
          '& .MuiAccordionSummary-expandIconWrapper svg': {
            width: '24px',
            height: '24px',
          },
        }}>
          <div className='broker-commission__title'>
            <div className='broker-commission__name'>
              <LocalPolice color={COLORS.GREEN} className='broker-commission__icon'/>
              <Typography variant='h6' sx={{
                color: COLORS.BLACK_DARK,
                fontSize: '20px',
                fontWeight: 700,
                lineHeight: '26px',
                letterSpacing: 0,
              }}>
                {formatDemoCopy(t('calc__text__customs__customsBrokerCommission'))}
              </Typography>
            </div>
            <Typography variant='h6' sx={{
              color: COLORS.BLACK_DARK,
              fontSize: '20px',
              fontWeight: 400,
              lineHeight: '26px',
              letterSpacing: 0,
              flexShrink: 0,
            }}>
              {commission}
            </Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails sx={{padding: '24px'}}>
          <Completed info={completedInfo} isFullRow/>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default BrokerCommission;
